import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon } from "@material-ui/core";
import GetFlag from "helpers/GetFlag";

export default function LanguageMenu({
	selectedConversation,
	languages,
	handleChangeConvLanguage
}) {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = event => {
		if (selectedConversation?.header?.state !== "archived") {
			setAnchorEl(event.currentTarget);
		}
	};

	const handleClose = language => {
		if (language) {
			handleChangeConvLanguage(language);
		}
		setAnchorEl(null);
	};

	return (
		<>
			<IconButton onClick={handleClick}>
				<img
					src={GetFlag(selectedConversation?.header?.language || "")}
					alt="flag"
					width="20"
					height="20"
					style={{ objectFit: "contain" }}
				/>
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={() => handleClose()}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				transformOrigin={{ vertical: "top", horizontal: "center" }}
				PaperProps={{
					style: {
						minWidth: 0,
						width: "auto",
						padding: "4px"
					}
				}}
			>
				{languages.map(language => (
					<MenuItem key={language?.code} onClick={() => handleClose(language?.code)}>
						<ListItemIcon style={{ minWidth: 0 }}>
							<img
								src={GetFlag(language?.code)}
								alt={language?.code}
								width="20"
								height="20"
								style={{ objectFit: "contain" }}
							/>
						</ListItemIcon>
					</MenuItem>
				))}
			</Menu>
		</>
	);
}
